/*
 *  eXide - web-based XQuery IDE
 *  
 *  Copyright (C) 2013 Wolfgang Meier
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
eXide.namespace("eXide.edit.SnippetModeHelper");

/**
 * XML specific helper methods.
 */
eXide.edit.SnippetModeHelper = (function () {
    
    Constr = function(editor) {
		this.parent = editor;
		this.editor = this.parent.editor;
	};
	
	eXide.util.oop.inherit(Constr, eXide.edit.ModeHelper);

    Constr.prototype.documentSaved = function(doc) {
        var code = doc.getText();
        var mode = doc.getName().replace(/\.snippets/, "");
        eXide.util.Snippets.reload(mode, code);
    };
    
	return Constr;
}());
